import { FC } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useOrderDetailsApi } from '@/features/orders/hooks/useOrderDetailsApi';
import { OrderStatus } from '@/features/orders/types/orders-dto';

type Props = {
	success: boolean;
};

const PaymentResultPage: FC<Props> = ({ success }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const orderId = searchParams.get('orderId') ?? undefined;

	const { orderDetailsData, isLoadingOrderDetailsData } = useOrderDetailsApi({
		id: orderId,
		refetchInterval: success && orderId ? 2000 : false,
	});

	const isProcessing =
		success &&
		!!orderId &&
		!isLoadingOrderDetailsData &&
		orderDetailsData?.status === OrderStatus.PendingPayment;

	const title = isProcessing
		? t('main.payments.result.processing.title')
		: success
			? t('main.payments.result.success.title')
			: t('main.payments.result.failed.title');

	const description = isProcessing
		? t('main.payments.result.processing.description')
		: success
			? t('main.payments.result.success.description')
			: t('main.payments.result.failed.description');

	return (
		<section className="flex-1 flex flex-col items-center justify-center gap-6 p-6 text-center">
			<div className="flex flex-col gap-2 max-w-md">
				<h1 className="text-2xl font-semibold">{title}</h1>
				<p className="text-popover-700">{description}</p>
			</div>
			<Button onClick={() => navigate('/orders')}>
				{t('main.payments.result.goToOrders')}
			</Button>
		</section>
	);
};

export default PaymentResultPage;
